// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__fTopt","left":"InfoRow_left__2ipcn"};